import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import React from "react";
import { memo } from "react";
import { sizes } from "../../../../constants/spacing";
import { Checkbox } from "../../../checkbox";
var noopClickHandler = function noopClickHandler() {
  // Nothing here intentionally - the Checkbox is purely presentational.
  // Its state is controlled by its parents.
};
var MultiSelectCheckboxStyled = /*#__PURE__*/memo(styled(Checkbox)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-right: ", "px;\n    vertical-align: middle;\n"])), sizes.xSmall));
export var MultiSelectCheckbox = function MultiSelectCheckbox(props) {
  return /*#__PURE__*/React.createElement(MultiSelectCheckboxStyled, _extends({
    "aria-hidden": true,
    useAriaDisabled: true,
    omitHiddenInput: true
  }, props, {
    tabIndex: -1,
    onClick: noopClickHandler
  }));
};
//# sourceMappingURL=MultiSelectCheckbox.js.map